import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import BaseIconButtonWithTooltip from '../BaseIconButtonWithTooltip';
import ButtonWithMenu from '../ButtonWithMenu';
/**
 * Komponent tlacitka s ikonou. Podporuje zobrazeni dropdown menu, pokud dostame MenuItemy jako
 * children.
 */

function IconButtonWithTooltip(props) {
  var children = props.children,
      menuPlacement = props.menuPlacement,
      rest = _objectWithoutProperties(props, ["children", "menuPlacement"]);

  return children ? React.createElement(ButtonWithMenu, _extends({}, rest, {
    menuPlacement: menuPlacement
  }), children) : React.createElement(BaseIconButtonWithTooltip, rest);
}

IconButtonWithTooltip.propTypes = {
  /**
   * Polozky menu. Zobrazujici se po kliknuti na button
   */
  children: PropTypes.node,

  /**
   * Button color.
   *
   * @colorPropType
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'inherit']),

  /**
   * pokud je `true` button je disablovany.
   */
  disabled: PropTypes.bool,

  /**
   * Ikona tlacitka.
   */
  icon: PropTypes.element.isRequired,

  /**
   * Barva ikony.
   */
  iconColor: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * Popis buttonu.
   */
  label: PropTypes.string,

  /**
   * Umisteni menu
   *
   * @placementPropType
   */
  menuPlacement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Funkce onClick
   */
  onClick: PropTypes.func,

  /**
   * Umisteni tooltipu
   *
   * @placementPropType
   */
  tooltipPlacement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'])
};
IconButtonWithTooltip.defaultProps = {
  children: null,
  color: undefined,
  disabled: false,
  iconColor: undefined,
  label: '',
  menuPlacement: undefined,
  onClick: undefined,
  tooltipPlacement: 'bottom'
};
export default IconButtonWithTooltip;